import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

/**
 * Hidden helper route at /b/:slug that, for an already-logged-in super_admin,
 * sets the acting branch in localStorage, refreshes the auth context, and
 * redirects to /dashboard so they can browse the branch as if they were its admin.
 */
export default function SuperEnterBranch() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { setActingBranch, refreshUser } = useAuth();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!slug) {
        navigate('/super/branches');
        return;
      }
      setActingBranch(slug);
      try {
        await refreshUser();
        if (cancelled) return;
        toast.success(`تم الدخول لفرع ${slug}`);
        navigate('/dashboard');
      } catch (_e) {
        if (cancelled) return;
        setActingBranch(null);
        toast.error('تعذّر الدخول للفرع');
        navigate('/super/branches');
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return (
    <div className="min-h-screen flex items-center justify-center" dir="rtl">
      <div className="text-lg">جاري الدخول للفرع...</div>
    </div>
  );
}
